import { Component, NgZone, OnInit, inject } from '@angular/core';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { DataSnapshot } from 'firebase/database';
import { bannerTransition } from '../animations';
import { FirebaseService } from '../firebase/firebase.service';
import { materialModules } from '../material.module';
import { BannerService } from './banner.service';

dayjs.extend(duration);

@Component({
  selector: 'ez-system-banner',
  templateUrl: './system-banner.component.html',
  styleUrls: ['./system-banner.component.scss'],
  animations: [bannerTransition],
  imports: [
    materialModules,
  ],
})
export class SystemBannerComponent implements OnInit {

  readonly #firebaseService = inject(FirebaseService);
  readonly #ngZone = inject(NgZone);
  readonly #bannerService = inject(BannerService);
  protected message = this.#bannerService.systemBannerMessage;
  protected bannerType = this.#bannerService.systemBannerType;

  ngOnInit(): void {
    this.#setupSystemMessageListener();
  }

  protected dismissBanner(): void {
    this.#bannerService.dismissSystemBanner();
  };

  #setupSystemMessageListener(): void {
    this.#firebaseService.watchSystemMessageNode((snapshot: DataSnapshot) => {
      const msg = JSON.parse(snapshot?.val()) || '';
      this.#ngZone.run(() => {
        if (msg) {
          this.#bannerService.showSystemBanner({
            content: msg,
            bannerType: 'primary',
          });
        } else {
          this.#bannerService.dismissSystemBanner();
        }
      });
    });
  }
}
